import {
    AfterViewInit,
    Component, EventEmitter,
    Input,
    OnChanges, Output,
    SimpleChanges
} from '@angular/core';
import { PaymentMethodModel } from '../../../../../../shared/models/payment-method.model';
import { InstallmentModel } from '../../../../../../shared/models/installment.model';
import { PaymentService } from '../../../../../services/payment.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Response } from '@angular/http';
import { CommonHttpService } from '../../../../../../shared/services/http.service';

@Component({
    'selector': 'payment-payment-option-card-option-multiple-cards-installments',
    'templateUrl': './payment.payment.option.card.option.multiple-cards-installments.component.html'
})
export class PaymentPaymentOptionCardOptionMultipleCardsInstallmentsComponent implements OnChanges {
    @Input() index: number;
    @Input() cardIndex: number;
    @Input() cardsCount: Array<number>;
    @Input() paymentMethod: PaymentMethodModel;
    @Input() deliverable: boolean;
    @Input() amountDifference: number;
    @Input() total: number;
    @Input() amount: number;
    @Input() mustReload: boolean;
    @Output() filled: EventEmitter<number> = new EventEmitter();
    @Output() reloaded: EventEmitter<null> = new EventEmitter();
    public loading = false;
    public installmentModelValue: number = 1;
    public installments: Array<InstallmentModel> = [];
    protected currencyPipe = new CurrencyPipe('pt-BR');
    protected percentPipe = new DecimalPipe('pt-BR');

    constructor(
        private paymentService: PaymentService,
        private http: CommonHttpService
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        let mustRefreshInstallments = changes.hasOwnProperty('mustReload')
            && (
                changes['mustReload'].currentValue === true
                || changes['mustReload'].firstChange === true
            );

        if (mustRefreshInstallments) {
            this.fetchInstallments();
        }
    }

    public buildInstallmentTranslation(installment: InstallmentModel): any {
        const params = {
            'installmentNumber': installment.number,
            'formattedInstallmentAmount': this.toCurrency(installment.amount)
        };
        if (installment.interest > 0) {
            params['formattedInstallmentInterest'] = this.toDecimal(installment.interest);
            params['formattedInstallmentInterestAmount'] = this.toCurrency(installment.interest_amount);
        }

        if (installment.discount_amount_installment > 0) {
            params['formattedInstallmentDiscount'] = this.toDecimal(installment.discount_amount_installment);
            params['formattedInstallmentDiscountAmount'] = this.toCurrency(installment.amount);
            params['porcentInstallmentDiscountAmount'] = this.percentPipe.transform(installment.percentage_discount, '1.0-2');
        }

        return params;
    }
    public hasInterest(installment: InstallmentModel) {
        return installment.interest > 0;
    }
    public hasDiscount(installment: InstallmentModel) {
        return (installment.discount_amount_installment != undefined && installment.discount_amount_installment != null && installment.discount_amount_installment > 0);
    }
    public onChangeInstallments(installment) {
        this.registerInstallmentsForMultipleCards(installment);
        this.filled.emit(this.installmentModelValue);
    }
    private registerInstallmentsForMultipleCards(installment) {
        const installmentsNumber = parseInt(installment, 0);
        this.installmentModelValue = installmentsNumber;
    }
    private toCurrency(value: number) {
        return this.currencyPipe.transform(
            value,
            'BRL',
            true,
            '1.2-2'
        );
    }
    private toDecimal(value: number) {
        return this.percentPipe.transform(value, '1.0-2');
    }
    private fetchInstallments() {
        let amount = this.amount;
        if (this.cardIndex > 1) {
            amount = this.amountDifference;
        }

        this.loading = true;
        this.installments = [];
        this.http.useAuth().get(
            `/checkout/payment/payment-methods/${this.paymentMethod.id}/installments?total=`+amount
        ).subscribe((res: Response) => {
            const installments: Array<InstallmentModel> = [];
            for (let installment of res.json().data) {
                installments.push(new InstallmentModel(
                    installment.number,
                    installment.interest,
                    installment.minimum_value,
                    installment.amount,
                    installment.interest_amount,
                    installment.percentage_interest,
                    installment.discount_amount_installment,
                    installment.percentage_discount,
                    installment.id
                ));
            }
            this.installments = installments;
            this.loading = false;
            this.reloaded.emit(null);
        }, () => {
            this.loading = false;
            this.reloaded.emit(null);
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/payment/payment/option/card/option/multiple-cards-installments/payment.payment.option.card.option.multiple-cards-installments.component.ts